// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"FaqA_TheComp__qJytv"};